/* Super Socks – „Wird oft zusammen gekauft“ (Test ab Oktober 2026)
 *
 * Bei den Testprodukten (snippets/ss-empfehlungen.liquid) übernimmt diese Karte
 * nach „In den Warenkorb“ die Rolle des Warenkorb-Drawers: Der Drawer fragt bei
 * jedem erfolgreichen /cart/add nach SSEmpfehlung.uebernimm(body). Ist es das
 * Produkt der Seite, öffnet sich die Karte und der Drawer bleibt zu.
 *
 * - Oben das eben hinzugefügte Produkt mit Preis wie im Warenkorb (Rabatt
 *   durchgestrichen) und das Gratis-Goodie, darunter der Stand zum Gratisversand.
 * - Drei Empfehlungen: die ersten verfügbaren, die noch nicht im Warenkorb
 *   liegen. Vorausgewählt ist die Größe, die gerade gewählt wurde.
 * - Preise zeigen einen Rabattcode aus dem Warenkorb (z. B. Rabattlink) so, wie
 *   der Warenkorb ihn rechnen wird.
 * - Hinzugefügte Empfehlungen bekommen das unsichtbare Merkmal _empfehlung
 *   (Produkt der Seite); dataLayer-Ereignisse ss_empfehlung_gezeigt und
 *   ss_empfehlung_hinzugefuegt, falls Google Tag Manager geladen ist.
 * Wegen InstantClick wird das Markup bei jedem Aufruf frisch gesucht.
 */
(function () {
  'use strict';
  if (window.SSEmpfehlung) return;

  var ICON_TRUCK = '<svg class="ss-ship__icon" width="24" height="24" viewBox="0 0 28 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M1.5 8.5h3.5M2.5 12h2.5"/><rect x="7" y="4" width="11" height="12" rx="1"/><path d="M18 8h4l3 4v4h-7"/>' +
    '<circle cx="11" cy="18" r="2"/><circle cx="21.5" cy="18" r="2"/></svg>';
  var ICON_HOME = '<svg class="ss-ship__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M3 11l9-7 9 7"/><path d="M5 9.5V20h14V9.5"/><path d="M10 20v-6h4v6"/></svg>';
  var ICON_GESCHENK = '<svg class="ss-emp__goodie-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/>' +
    '<path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';
  var ICON_HAKEN = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  var lastPct = 0;

  function karte() { return document.getElementById('ss-karte-empfehlung'); }
  function alle(el, sel) { return el ? [].slice.call(el.querySelectorAll(sel)) : []; }

  function esc(s) {
    return String(s === null || s === undefined ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  function money(cents) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function schwelle(k) {
    var base = parseInt(k.getAttribute('data-schwelle') || '2500', 10);
    var rate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    return rate && rate > 0 ? Math.round(base * rate) : base;
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function melden(daten) {
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(daten);
  }

  /* ---------- Bilder erst nach dem Laden der Seite holen ---------- */
  function bilderLaden() {
    alle(karte(), 'img[data-src]').forEach(function (img) {
      if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  }
  function spaeterLaden() { setTimeout(bilderLaden, 1500); }
  if (document.readyState === 'complete') spaeterLaden();
  else window.addEventListener('load', spaeterLaden);
  /* wer zum Warenkorb-Knopf greift, bekommt die Bilder sofort */
  document.addEventListener('pointerdown', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) bilderLaden();
  }, { capture: true, passive: true });

  /* ---------- Wurde das Produkt der Seite hinzugefügt? ---------- */
  function ausBody(body) {
    var id = null, eigen = false;
    try {
      if (!body) return { id: null, eigen: false };
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        id = body.get('id');
        eigen = body.has('properties[_empfehlung]');
      } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        id = body.get('id');
        eigen = body.has('properties[_empfehlung]');
      } else if (typeof body === 'string') {
        var s = body.trim();
        if (s.charAt(0) === '{') {
          var j = JSON.parse(s);
          var it = j.items && j.items[0] ? j.items[0] : j;
          id = it.id;
          eigen = !!(it.properties && it.properties._empfehlung);
        } else {
          var q = new URLSearchParams(s);
          id = q.get('id');
          eigen = q.has('properties[_empfehlung]');
        }
      }
    } catch (e) {}
    return { id: parseInt(id, 10) || null, eigen: eigen };
  }

  /* Vom Drawer gefragt: true = Karte übernimmt, Drawer bleibt zu */
  function uebernimm(body) {
    var k = karte();
    if (!k) return false;
    var b = ausBody(body);
    if (b.eigen) return true;
    var varianten = (k.getAttribute('data-varianten') || '').split(',');
    if (!b.id || varianten.indexOf(String(b.id)) === -1) return false;
    oeffnen(b.id);
    return true;
  }

  /* ---------- Rabatte wie im Warenkorb ---------- */
  function rabattListe(k) {
    var m = {};
    (k.getAttribute('data-rabatte') || '').split(',').forEach(function (e) {
      var t = e.split('='), w = (t[1] || '').split(':');
      if (t[0] && w[0]) m[t[0].trim().toUpperCase()] = { kollektion: w[0].trim(), prozent: parseFloat(w[1]) || 0 };
    });
    return m;
  }

  function rabatte(cart, k) {
    var liste = [], gesehen = {}, karteRabatte = rabattListe(k);
    function nimm(a) {
      if (!a || a.target_type !== 'line_item' || a.value_type !== 'percentage') return;
      var code = String(a.title || '');
      var key = code + '|' + a.target_selection;
      if (gesehen[key]) return;
      gesehen[key] = true;
      var info = karteRabatte[code.toUpperCase()];
      liste.push({ alle: a.target_selection === 'all', prozent: parseFloat(a.value) || 0, kollektion: info ? info.kollektion : null });
    }
    (cart.items || []).forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (d) { nimm(d.discount_application); });
    });
    (cart.cart_level_discount_applications || []).forEach(nimm);
    /* Codes im Warenkorb, die noch für keinen Artikel greifen */
    (cart.discount_codes || []).forEach(function (d) {
      var info = karteRabatte[String(d.code || '').toUpperCase()];
      if (!d.applicable && info) liste.push({ alle: false, prozent: info.prozent, kollektion: info.kollektion });
    });
    return liste;
  }

  function prozentFuer(li, liste) {
    var kol = (li.getAttribute('data-kollektionen') || '').split(',');
    var best = 0;
    liste.forEach(function (r) {
      var gilt = r.alle || (r.kollektion && kol.indexOf(r.kollektion) > -1);
      if (gilt && r.prozent > best) best = r.prozent;
    });
    return best;
  }

  /* Shopify rundet den Rabatt je Artikel auf den Cent ab (geprüft: 29,95 € −10 % = 26,96 €) */
  function preisHtml(preis, vergleich, prozent) {
    var jetzt = prozent > 0 ? preis - Math.floor(preis * prozent / 100 + 1e-6) : preis;
    var vorher = prozent > 0 ? (vergleich > preis ? vergleich : preis) : (vergleich > preis ? vergleich : 0);
    return (vorher > jetzt ? '<s>' + money(vorher) + '</s> ' : '') + '<span class="ss-emp__jetzt">' + money(jetzt) + '</span>';
  }

  /* ---------- Darstellen ---------- */
  /* Gratis-Goodie wie im Warenkorb-Drawer (Daten aus snippets/ss-cart-drawer.liquid) */
  function goodieHtml() {
    var el = document.getElementById('ss-gift-data');
    var g = null;
    try { g = el ? JSON.parse(el.textContent) : null; } catch (e) {}
    if (!g || !g.title) return '';
    var v = (g.variants || [])[0];
    var wert = (v && v.price) || g.price || 0;
    return '<div class="ss-emp__goodie">' + ICON_GESCHENK +
      '<span class="ss-emp__goodie-text"><strong>Gratis-Goodie:</strong> ' + esc(g.title) + '</span>' +
      '<span class="ss-emp__goodie-preis">' + (wert ? '<s>' + money(wert) + '</s>' : '') + '<span class="ss-emp__jetzt">' + money(0) + '</span></span>' +
    '</div>';
  }

  function hauptZeile(k, item) {
    var el = k.querySelector('[data-ss-emp-haupt]');
    if (!el) return;
    if (!item) { el.innerHTML = ''; el.hidden = true; return; }
    var groesse = '';
    (item.options_with_values || []).forEach(function (o) { if (o.name === 'Größe') groesse = o.value; });
    if (!groesse && item.variant_title && item.variant_title !== 'Default Title') groesse = item.variant_title;
    var was = item.original_line_price;
    var off = typeof item.total_discount === 'number' ? item.total_discount : was - item.final_line_price;
    var now = Math.max(0, was - off);
    var bild = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
    el.hidden = false;
    el.innerHTML =
      '<div class="ss-emp__zeile">' +
        (bild ? '<img src="' + esc(bild) + '" alt="" width="56" height="56" decoding="async">' : '') +
        '<div class="ss-emp__haupt-text">' +
          '<p class="ss-emp__haupt-name">' + esc(item.product_title) + '</p>' +
          '<p class="ss-emp__haupt-var">' + (groesse ? 'Größe: ' + esc(groesse) : '') + (item.quantity > 1 ? ' · Menge: ' + item.quantity : '') + '</p>' +
        '</div>' +
        '<p class="ss-emp__haupt-preis">' + (now < was ? '<s>' + money(was) + '</s>' : '') + '<span class="ss-emp__jetzt">' + money(now) + '</span></p>' +
      '</div>' +
      goodieHtml();
  }

  function versand(k, cart) {
    var el = k.querySelector('[data-ss-emp-versand]');
    if (!el) return;
    var goal = schwelle(k);
    var rest = goal - cart.total_price;
    var pct = Math.max(0, Math.min(100, cart.total_price / goal * 100));
    var done = rest <= 0;
    el.innerHTML =
      '<div class="ss-ship' + (done ? ' is-done' : '') + '">' +
        '<div class="ss-ship__bar">' + ICON_TRUCK +
          '<div class="ss-ship__track" role="progressbar" aria-label="Fortschritt bis zum kostenlosen Versand" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '">' +
            '<div class="ss-ship__fill" style="width:' + lastPct + '%"></div>' +
          '</div>' + ICON_HOME +
        '</div>' +
        '<p class="ss-ship__text">' + (done ? 'Geschafft! Versand ist kostenlos.' : 'Noch <strong>' + money(rest) + '</strong> bis zum kostenlosen Versand.') + '</p>' +
      '</div>';
    var fill = el.querySelector('.ss-ship__fill');
    void fill.offsetWidth;
    fill.style.width = pct + '%';
    lastPct = pct;
  }

  function groesseWaehlen(li, wert) {
    var sel = li.querySelector('[data-ss-emp-variante]');
    if (!sel) return;
    var opts = [].slice.call(sel.options);
    var w = String(wert || '').toLowerCase();
    var treffer = opts.filter(function (o) { return !o.disabled && String(o.getAttribute('data-wert')).toLowerCase() === w; })[0] ||
      opts.filter(function (o) { return !o.disabled; })[0];
    if (treffer) sel.value = treffer.value;
  }

  function preisZeigen(li, liste) {
    var sel = li.querySelector('[data-ss-emp-variante]');
    var o = sel && sel.options[sel.selectedIndex];
    var p = li.querySelector('[data-ss-emp-preis]');
    if (!o || !p) return;
    p.innerHTML = preisHtml(parseInt(o.getAttribute('data-preis'), 10) || 0, parseInt(o.getAttribute('data-vergleich'), 10) || 0, prozentFuer(li, liste));
  }

  function knopf(li, zustand) {
    var b = li.querySelector('[data-ss-emp-dazu]');
    if (!b) return;
    li.setAttribute('data-zustand', zustand);
    b.classList.toggle('is-drin', zustand === 'drin');
    b.disabled = zustand === 'laedt' || zustand === 'drin';
    b.innerHTML = zustand === 'drin' ? ICON_HAKEN + 'Hinzugefügt' : zustand === 'laedt' ? 'Wird hinzugefügt…' : 'Hinzufügen';
  }

  /* Welche drei werden gezeigt: verfügbar, nicht schon im Warenkorb. Was in
     dieser Karte gerade hinzugefügt wurde, bleibt stehen (mit Häkchen). */
  function auswahl(k, cart, groesse) {
    var imKorb = {};
    (cart.items || []).forEach(function (i) { imKorb[i.product_id] = true; });
    var liste = rabatte(cart, k);
    var n = 0, gezeigt = [];
    alle(k, '.ss-emp__produkt').forEach(function (li) {
      var bleibt = li.getAttribute('data-zustand') === 'drin';
      var frei = alle(li, 'option').some(function (o) { return !o.disabled; });
      var zeigen = n < 3 && frei && (bleibt || !imKorb[li.getAttribute('data-produkt-id')]);
      li.hidden = !zeigen;
      if (!zeigen) return;
      n++;
      gezeigt.push(li.getAttribute('data-handle'));
      if (!bleibt) {
        knopf(li, 'frei');
        groesseWaehlen(li, groesse);
      }
      preisZeigen(li, liste);
    });
    var z = k.querySelector('[data-ss-emp-zwischen]');
    if (z) z.hidden = n === 0;
    return gezeigt;
  }

  /* ---------- Öffnen ---------- */
  /* Turbo sperrt nach dem Hinzufügen die Seite für seinen alten Mini-Warenkorb
     (body.blocked-scroll = keine Klicks), und zwar erst rund eine Sekunde nach
     dem Öffnen der Karte. Wie beim Schließen des Drawers aufräumen: solange die
     Karte offen ist und mindestens 4 Sekunden lang. */
  var waechter = null;
  function turboAufraeumen() {
    document.body.classList.remove('blocked-scroll', 'is-active');
    alle(document, '.cart-container.active_link').forEach(function (el) { el.classList.remove('active_link'); });
  }
  function turboBewachen(k) {
    var bis = Date.now() + 4000;
    if (waechter) waechter.disconnect();
    turboAufraeumen();
    if (!window.MutationObserver) return;
    waechter = new MutationObserver(function () {
      if (!k.classList.contains('is-offen') && Date.now() > bis) { waechter.disconnect(); waechter = null; return; }
      var b = document.body.classList;
      if (b.contains('blocked-scroll') || b.contains('is-active')) turboAufraeumen();
    });
    waechter.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  /* Am Handy beginnt die Karte unter der Kopfzeile (wie bei Snocks). In der
     Theme-Vorschau bleibt unten Platz für Shopifys Vorschauleiste. */
  function lageSetzen(k) {
    var kopf = document.querySelector('header.mobile_nav-fixed--true') ||
      document.querySelector('.shopify-section--header header');
    var oben = kopf ? Math.round(kopf.getBoundingClientRect().bottom) : 0;
    if (!(oben > 0 && oben < 160)) oben = 0;
    k.style.setProperty('--ss-emp-oben', oben + 'px');
    var bar = document.getElementById('PBarNextFrameWrapper');
    var unten = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    k.style.setProperty('--ss-emp-unten', unten + 'px');
    var blatt = k.querySelector('.ss-karte__blatt');
    if (blatt) blatt.scrollTop = 0;
    var liste = k.querySelector('.ss-emp__liste');
    if (liste) liste.scrollLeft = 0;
  }

  function oeffnen(variantId) {
    var k = karte();
    if (!k) return;
    if (k.parentNode !== document.body) document.body.appendChild(k);
    bilderLaden();
    alle(k, '.ss-emp__produkt').forEach(function (li) { li.removeAttribute('data-zustand'); });
    getCart().then(function (cart) {
      var item = (cart.items || []).filter(function (i) {
        return i.variant_id === variantId && !(i.properties && i.properties._empfehlung);
      })[0] || (cart.items || []).filter(function (i) { return i.variant_id === variantId; })[0];
      var groesse = '';
      if (item) (item.options_with_values || []).forEach(function (o) { if (o.name === 'Größe') groesse = o.value; });
      hauptZeile(k, item);
      versand(k, cart);
      var gezeigt = auswahl(k, cart, groesse);
      lageSetzen(k);
      turboBewachen(k);
      if (window.SSKarten && SSKarten.oeffnen('empfehlung')) {
        /* ok */
      } else {
        k.setAttribute('aria-hidden', 'false');
        k.classList.add('is-offen');
      }
      if (window.SSDrawer && SSDrawer.refresh) SSDrawer.refresh(); /* Zähler im Kopf und Versandleiste mitziehen */
      melden({ event: 'ss_empfehlung_gezeigt', ss_produkt: k.getAttribute('data-quelle'), ss_empfehlungen: gezeigt.join(',') });
    }).catch(function () {
      if (window.SSDrawer) SSDrawer.open({ pop: true });
    });
  }

  function schliessen() {
    var k = karte();
    if (window.SSKarten) SSKarten.schliessen(true);
    else if (k) { k.classList.remove('is-offen'); k.setAttribute('aria-hidden', 'true'); }
  }

  /* ---------- Hinzufügen ---------- */
  function hinzufuegen(li) {
    var k = karte();
    var sel = li.querySelector('[data-ss-emp-variante]');
    var fehler = li.querySelector('[data-ss-emp-fehler]');
    if (!k || !sel || !sel.value) return;
    var pos = alle(k, '.ss-emp__produkt').filter(function (x) { return !x.hidden; }).indexOf(li) + 1;
    if (fehler) { fehler.hidden = true; fehler.textContent = ''; }
    knopf(li, 'laedt');
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(sel.value, 10), quantity: 1, properties: { _empfehlung: k.getAttribute('data-quelle') } }] })
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    }).then(function () {
      knopf(li, 'drin');
      melden({ event: 'ss_empfehlung_hinzugefuegt', ss_produkt: k.getAttribute('data-quelle'), ss_empfehlung: li.getAttribute('data-handle'), ss_position: pos });
      return getCart().then(function (cart) {
        versand(k, cart);
        var liste = rabatte(cart, k);
        alle(k, '.ss-emp__produkt').forEach(function (x) { if (!x.hidden) preisZeigen(x, liste); });
        if (window.SSDrawer && SSDrawer.refresh) SSDrawer.refresh();
      });
    }).catch(function (err) {
      knopf(li, 'frei');
      if (fehler) {
        fehler.textContent = (err && (err.description || err.message)) || 'Das hat nicht geklappt. Bitte noch einmal versuchen.';
        fehler.hidden = false;
      }
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var k = karte();
    if (!k || !t || !t.closest || !k.contains(t)) return;
    var dazu = t.closest('[data-ss-emp-dazu]');
    if (dazu) { e.preventDefault(); hinzufuegen(dazu.closest('.ss-emp__produkt')); return; }
    if (t.closest('[data-ss-emp-kasse]')) {
      e.preventDefault();
      if (window.SSDrawer && SSDrawer.checkout) SSDrawer.checkout();
      else window.location.href = '/checkout';
      return;
    }
    if (t.closest('[data-ss-emp-warenkorb]')) {
      e.preventDefault();
      schliessen();
      if (window.SSDrawer) SSDrawer.open();
    }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target;
    var k = karte();
    if (!k || !sel || !sel.matches || !sel.matches('[data-ss-emp-variante]') || !k.contains(sel)) return;
    var li = sel.closest('.ss-emp__produkt');
    knopf(li, 'frei');
    getCart().then(function (cart) { preisZeigen(li, rabatte(cart, k)); }).catch(function () {});
  });

  window.SSEmpfehlung = { uebernimm: uebernimm, oeffnen: oeffnen };
})();
